import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "card", "prevBtn", "nextBtn"];

  connect() {
    this.resizeObserver = new ResizeObserver(() => this.#updateArrows());
    this.resizeObserver.observe(this.containerTarget);

    this.scrollTimeout = null;
    this.onScroll = () => {
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = setTimeout(() => this.#updateArrows(), 100);
    };
    this.containerTarget.addEventListener("scroll", this.onScroll, {
      passive: true,
    });
  }

  disconnect() {
    this.resizeObserver.disconnect();
    this.containerTarget.removeEventListener("scroll", this.onScroll);
    clearTimeout(this.scrollTimeout);
  }

  next() {
    if (!this.hasCardTarget) return;

    const scrollAmount = this.cardTarget.offsetWidth + 12; // card width + gap
    this.containerTarget.scrollBy({ left: scrollAmount, behavior: "smooth" });
  }

  previous() {
    if (!this.hasCardTarget) return;

    const scrollAmount = this.cardTarget.offsetWidth + 12;
    this.containerTarget.scrollBy({ left: -scrollAmount, behavior: "smooth" });
  }

  #updateArrows() {
    const { scrollLeft, scrollWidth, clientWidth } = this.containerTarget;

    if (this.hasPrevBtnTarget) {
      this.prevBtnTarget.classList.toggle("!hidden", scrollLeft <= 5);
    }

    if (this.hasNextBtnTarget) {
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 5;
      this.nextBtnTarget.classList.toggle("!hidden", atEnd);
    }
  }
}
